import { Theme } from '@mui/material/styles/createTheme';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useNotificationStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuIconCount: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      width: 24,
      height: 24,
      backgroundColor: theme.palette.primaryColor,
      color: theme.palette.mainLight,
      fontWeight: 600,
      fontSize: 11,
      lineHeight: '24px',
      fontFamily: 'Open Sans',
    }
  })
);
